const module = { name: 'desktop/shared/sw-install', exports: {} }; const exports = module.exports;



const SERVICE_WORKER_FILE = '/sw-desktop.js'


const SERVICE_WORKER_OPTIONS = {
    scope: '/'
}
function onNewServiceWorker(registration, callback) {
    if (registration.waiting) {
        return callback();
    }
    function listenInstalledStateChange() {
        registration.installing.addEventListener('statechange', (event) => {
            if (event.target.state === 'installed') {
                return callback();
            }
        });
    }
    if (registration.installing) {
        return listenInstalledStateChange();
    }
    registration.addEventListener('updatefound', listenInstalledStateChange);
}
function onFailInitSw(err) {
    console.log('ServiceWorker registration failed: ', err);
}
function onSuccessInitSw(registration) {
    if (!navigator.serviceWorker.controller) {
        console.log('ServiceWorker registration successful with scope: ', registration.scope);
        return;
    }
    onNewServiceWorker(registration, () => {
        registration.waiting.postMessage('skipWaiting');
    });
}
function onLoadInitServiceWorker() {
    navigator.serviceWorker.register(SERVICE_WORKER_FILE, SERVICE_WORKER_OPTIONS)
        .then(onSuccessInitSw)
        .catch(onFailInitSw);
}
module.exports = {
    onLoadInitServiceWorker
};
export default module.exports;